module.exports = __webpack_public_path__ + "img/bodyytalkanimal.36cc9201.svg";